/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Mostplayed2Inputs */

const id_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling Banyak Dimainkan`)
};

const ms_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling Banyak Dimainkan`)
};

const da_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest spillede`)
};

const de_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistgespielt`)
};

const en_us2_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Played`)
};

const es_es2_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más jugados`)
};

const es_mx2_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más jugados`)
};

const fil_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamalaro`)
};

const fr_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les plus joués`)
};

const it_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più giocati`)
};

const hu_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legtöbbet játszottak`)
};

const nl_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meest gespeeld`)
};

const no_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest spilte`)
};

const pl_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najczęściej grane`)
};

const pt_br2_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais jogados`)
};

const pt_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais jogados`)
};

const ro_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai jucate`)
};

const fi_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatuimmat`)
};

const sv_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest spelade`)
};

const vi_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi nhiều nhất`)
};

const tr_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok Oynananlar`)
};

const cs_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejhranější`)
};

const bg_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-играни`)
};

const ru_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые популярные`)
};

const uk_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпопулярніші`)
};

const ar_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر لعبًا`)
};

const hi_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबसे ज़्यादा खेले गए`)
};

const th_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นมากที่สุด`)
};

const ja_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最もプレイされた`)
};

const zh_cn2_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门游玩`)
};

const zh_hant1_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熱門遊玩`)
};

const ko_components_performancetable_collections_mostplayed2 = /** @type {(inputs: Components_Performancetable_Collections_Mostplayed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 많이 플레이됨`)
};

/**
* | output |
* | --- |
* | "Most Played" |
*
* @param {Components_Performancetable_Collections_Mostplayed2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_mostplayed2 = /** @type {((inputs?: Components_Performancetable_Collections_Mostplayed2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Mostplayed2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "da") return da_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "de") return de_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "it") return it_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "no") return no_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "th") return th_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_mostplayed2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_mostplayed2(inputs)
	return ko_components_performancetable_collections_mostplayed2(inputs)
});
export { components_performancetable_collections_mostplayed2 as "components.performanceTable.collections.mostPlayed" }